/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '../../../../src/app/components/content.component';
import * as i2 from '@angular/router';
import * as i3 from '../../../../src/app/order/currentOrder.service';
var styles_ContentComponent = [];
export var RenderType_ContentComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_ContentComponent, data: {} });
export function View_ContentComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 18, 'div', [['class',
                'row border-bottom shadow-bottom pt-lightnavy-bg']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n  '])),
        (_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class', 'col-sm-3 col-md-2 col-request-user pt-navy-bg no-padding-r']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'nav-header pt-navy-bg']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵeld(0, null, null, 1, 'a', [['class',
                'main-logo pt-content-logo'], ['href', '#']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.resetOrder() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n      '])),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n  '])),
        (_l()(), i0.ɵted(null, ['\n  '])), (_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class', 'col-sm-11 col-md-10 col-request-user pt-lightnavy-bg no-padding-r']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'header-quote']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n      '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'span', [['class', 'center-text']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n  '])),
        (_l()(), i0.ɵted(null, ['\n'])), (_l()(), i0.ɵted(null, ['\n\n'])),
        (_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class', 'gray-bg']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n  '])), (_l()(), i0.ɵted(null, ['\n  '])),
        (_l()(), i0.ɵted(null, ['\n  '])), (_l()(), i0.ɵted(null, ['\n  '])),
        (_l()(), i0.ɵeld(16777216, null, null, 1, 'router-outlet', [], null, null, null, null, null)),
        i0.ɵdid(212992, null, 0, i2.RouterOutlet, [i2.ChildrenOutletContexts, i0.ViewContainerRef,
            i0.ComponentFactoryResolver, [8, null], i0.ChangeDetectorRef], null, null), (_l()(), i0.ɵted(null, ['\n'])), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        _ck(_v, 26, 0);
    }, null);
}
export function View_ContentComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'cx-content', [], null, null, null, View_ContentComponent_0, RenderType_ContentComponent)),
        i0.ɵdid(49152, null, 0, i1.ContentComponent, [i3.CurrentOrderService], null, null)], null, null);
}
export var ContentComponentNgFactory = i0.ɵccf('cx-content', i1.ContentComponent, View_ContentComponent_Host_0, {}, {}, []);
//# sourceMappingURL=content.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./aot/src/app/components/content.component.ngfactory.js
// module id = 1199
// module chunks = 0